import { h } from "preact";
import { Tooltip } from "react-tooltip";

// Counter component
export function Counter({ value, onChange, min = 0, max = 50, label = "Quantity" }) {
  const increment = () => {
    // If value is 0 and there's a min requirement, jump to min
    if (value === 0 && min > 0) {
      onChange(min);
    } else if (value < max) {
      onChange(value + 1);
    }
  };

  const decrement = () => {
    // If there's a min requirement and we're exactly at min, reset to 0
    if (min > 0 && value === min) {
      onChange(0);
    } else {
      // Otherwise decrement normally
      onChange(Math.max(0, value - 1));
    }
  };

  return (
    <div className="flex justify-center">
      <button
        onClick={decrement}
        aria-label={`Decrease ${label}`}
        className="w-8 bg-gray-200 cursor-pointer hover:bg-gray-300 rounded-l border flex items-center justify-center leading-none"
        disabled={value <= 0}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-3 h-3"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M1.5 6h9"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </button>
      <input
        type="number"
        value={value}
        onChange={(e) => {
          const newValue = parseInt(e.target.value) || 0;
          // Allow 0, or enforce min/max when user types a value
          if (newValue === 0) {
            onChange(0);
          } else if (newValue < min) {
            onChange(min);
          } else if (newValue > max) {
            onChange(max);
          } else {
            onChange(newValue);
          }
        }}
        className="service-selector w-16 h-8 mb-0 text-center border-t border-b focus:outline-hidden"
        min={0}
        max={max}
        aria-label={label}
      />
      <button
        onClick={increment}
        aria-label={`Increase ${label}`}
        className="w-8 bg-gray-200 cursor-pointer hover:bg-gray-300 rounded-r border flex items-center justify-center leading-none"
        disabled={value >= max}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-3 h-3"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M6 1.5v9M1.5 6h9"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>
  );
}

// Info Icon
export function InfoIcon({ id, message }) {
  return (
    <div
      className="inline-flex items-center justify-center w-4 h-4 text-xs border border-gray-400 rounded-full ml-1 cursor-help"
      data-tooltip-id={id}
      data-tooltip-content={message}
    >
      ?
      <Tooltip
        id={id}
        className="max-w-[180px] whitespace-normal text-balance"
      />
    </div>
  );
}
